import { getElement } from "../shared/pageComponents";
import { computePosition, offset, flip, shift } from '@floating-ui/dom';

const headerNavbarWrap = getElement('headerNavbarWrap');

function setupDropdown(linkEl, menuEl) {
  let hoverTimeout;

  if (linkEl && menuEl) {
    const showMenu = async () => {
      clearTimeout(hoverTimeout);

      computePosition(linkEl, menuEl, {
            placement: "bottom-end",
            middleware: [offset(8), flip(), shift()],
        }).then(({ x, y }) => {
            Object.assign(menuEl.style, {
                top: `${y}px`,
                left: `${x}px`
            });
        });

      menuEl.classList.add("open", "position-fixed");
      linkEl.classList.add("show-dropdown");
      linkEl.setAttribute("aria-expanded", "true");
    };

    const hideMenu = () => {
      hoverTimeout = setTimeout(() => {
        menuEl.classList.remove("open");
        linkEl.classList.remove("show-dropdown");
        linkEl.setAttribute("aria-expanded", "false");
      }, 200);
    };

    linkEl.addEventListener("click", (e) => e.preventDefault());
    linkEl.addEventListener("mouseenter", showMenu);
    menuEl.addEventListener("mouseenter", showMenu);
    linkEl.addEventListener("mouseleave", hideMenu);
    menuEl.addEventListener("mouseleave", hideMenu);
  }
}

const productItemsLink = document.querySelector("#planBensHeader a");
const productItemsDropdownMenu = document.getElementById("solutionsDropdownMenu");

const beyondItemsLink = document.querySelector("#beyondBenefitsHeader a");
const beyondItemsDropdownMenu = document.getElementById("beyondsDropdownMenu");

const insightItemsLink = document.querySelector("#insightsHeader a");
const insightItemsDropdownMenu = document.getElementById("insightsDropdownMenu");

setupDropdown(productItemsLink, productItemsDropdownMenu);
setupDropdown(beyondItemsLink, beyondItemsDropdownMenu);
setupDropdown(insightItemsLink, insightItemsDropdownMenu);